import React from 'react'
import './Close.scss'

const Close = ({ size = 17.5, ...rest }) => (
	<div {...rest} style={{ width: `${size}px`, height: `${size}px` }} className='icon-close'/>
)

export default Close
